/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for the resource-processing reconciliation sweep.

Self-heals resources whose AI digest job never ran or died mid-flight (e.g. a
worker recycle killed the in-memory background task, or a creation path forgot
to trigger it) - there is no durable job status to detect this any other way.
 */
export interface ResourceProcessingReconcileParams {
  graceMinutes?: number;
  batchSize?: number;
}
